module.exports = __webpack_public_path__ + "static/media/GithubLogo.9b038c37.png";